export default __webpack_public_path__ + "static/media/password_on.368550c3.svg";